import { assoc, mapObjIndexed, replace } from 'ramda';
import { capitalizeFirst } from '../../functional';

/*
 * Given nothing, return a default MapNoteFilter
 * @sig fromDefault :: () -> MapNoteFilter
 */
const fromDefault = () => ({
    status: 'open',
    type: {
        noType: true,
        mapRequest: true,
        fieldVerify: true,
    },
});

/*
 * Given a new status and the current MapNoteFilter, return the filter with the specified status
 * @sig setStatus :: (string, MapNoteFilter) -> MapNoteFilter
 */
const setStatus = (selectedOption, mapNoteFilter) => assoc('status', selectedOption, mapNoteFilter);

/*
 * Given a new type and the current MapNoteFilter, return the filter with the specified type toggled
 * @sig toggleType :: (bool, MapNoteFilter) -> MapNoteFilter
 */
const toggleType = (selectedOption, mapNoteFilter) => {
    const checkOption = (val, key) => (key === selectedOption ? !mapNoteFilter.type[selectedOption] : val);
    return assoc('type', mapObjIndexed(checkOption, mapNoteFilter.type), mapNoteFilter);
};

/*
 * Given the property of a type (e.g. 'noType'), return a label with the words separated and capitalized (e.g. 'No
 * Type')
 * @sig titleFor :: string -> string
 */
const titleFor = typeProperty => capitalizeFirst(replace(/([A-Z])/g, ' $1', typeProperty));

export { fromDefault, toggleType, setStatus, titleFor };
